import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";
import TeachingSettings from "./lazy";

export default {
    component: TeachingSettings,
    renderSeo: (store: any, allMessage: {[ key: string]: string }, lang: string) => {
        return seo({
            title: allMessage["teachingSettings.title"],
            allMessage,
            lang,
            type: "article",
        });
    },
} satisfies IRoute;
